import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workout-edit-table',
  templateUrl: './workout-edit-table.component.html',
  styleUrls: ['./workout-edit-table.component.scss']
})
export class WorkoutEditTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
